import { PressEventsType } from '@osmosis/backend/orm-db';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import React from 'react';
import CurrentEventItem from './CurrentEventItem';

type Props = {
  events: PressEventsType[];
};

/**
 * List of current events.
 */
const CurrentEventsList = (props: Props) => {
  const { events } = props;
  return (
    <Box cn="flex flex-wrap sm:gap-4 gap-2">
      {events.map((e) => (
        <Box cn="sm:w-[30%] w-[45%]" key={e.eventId}>
          <CurrentEventItem event={e} />
        </Box>
      ))}
    </Box>
  );
};

export default CurrentEventsList;
